//@*/*
//    *RPD  Appv0.91
//    * Copyright (c) 2022, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//

/* eslint-disable */
//line_cnt_by_weeks
const home = () => import("../components/home.vue");
const report = () => import("../components/report.vue");
const searchResults = () => import("../components/searchResults.vue");
const barchart = () => import("../components/barchart.vue");
const piechart = () => import("../components/piechart.vue");
const pie_stop_type = () => import("../components/pie_stop_type.vue");
const line_cnt_by_weeks = () => import("../components/line_cnt_by_weeks.vue");
const help = () => import("../components/help.vue");
const tsep_form = () => import("../components/tsep_form.vue");
//admin
const admin = () => import("../components/admin.vue");
const pagenoutfound = () => import("../components/pagenoutfound.vue");
//tsep_form

export const routes = [
  { name: "home", path: "/", component: home, display: "Home", icon: "Home" },
  { name: "report", path: "/report", component: report, display: "report" },
  { name: "help", path: "/help", component: help, display: "Help" },
  {
    name: "admin",
    path: "/admin",
    component: admin,
    display: "ADMIN",
  },
  {
    name: "tsep_form",
    path: "/tsep_form",
    component: tsep_form,
    display: "TESP FORM",
  },

  {
    name: "barchart",
    path: "/barchart",
    component: barchart,
    display: "barchart",
  },
  {
    name: "piechart",
    path: "/piechart",
    component: piechart,
    display: "piechart",
  },
  {
    name: "pie_stop_type",
    path: "/pie_stop_type",
    component: pie_stop_type,
    display: "pie_stop_type",
  },
  {
    name: "line_cnt_by_weeks",
    path: "/line_cnt_by_weeks",
    component: line_cnt_by_weeks,
    display: "line_cnt_by_weeks",
  },
  {
    name: "searchResults",
    path: "/searchResults",
    component: searchResults,
    display: "searchResults",
  },
  { name: "not-found", path: "/:pathMatch(.*)*", component: pagenoutfound },
];
